<template>
  <v-progress-circular :color="rankingColor"
                       :size="size"
                       :value="model"
                       data-key="finScore"
                       rotate="270"
                       width="4">
    <span class="fin-color-primary-dark--text" style="font-weight: bold"> {{
        value || value === 0 ? Math.round(value) : '-'
      }}</span>
  </v-progress-circular>
</template>

<script>
export default {
  name: "finScore",
  props: {
    /**
     * Percentage value between 0-100
     */
    value: {
      type: Number
    },
    /**
     * See https://vuetifyjs.com/en/api/v-progress-circular/#props-size
     */
    size: {
      type: [Number, String],
      default: 36
    },
  },
  computed: {
    model() {
      if (this.value === null || this.value === undefined) {
        return
      }
      return this.value
    },
    /**
     * @return {String} Color of the circle
     */
    rankingColor() {
      if (this.value > 70) {
        return this.$finColors.accentGreen
      } else if (this.value > 50) {
        return this.$finColors.accentYellow
      } else {
        return this.$finColors.accentRed
      }
    },
  }
}
</script>

<style scoped>

</style>
